import { useEffect, useRef, useState } from 'react';
import { StyledTextWithTranslations } from './TextWithTranslations.styled';
import TranslationPopover from './TranslationPopover';

export default function TextWithTranslations({
  text,
  translations,
  className = '',
}) {
  const [selectedWord, setSelectedWord] = useState(null);

  const divRef = useRef(null);
  const updatedHtmlContent = translations?.length
    ? wrapWordsWithSpan(text, translations)
    : text;

  useEffect(() => {
    const handleClick = (event) => {
      event.stopPropagation();
      if (event.target.classList.contains('clickable-word')) {
        const wordIndex = event.target.getAttribute('data-index');
        setSelectedWord({
          element: event.target,
          ...translations[wordIndex],
        });
      }
    };

    const targetNode = divRef.current;

    if (targetNode) {
      targetNode.addEventListener('click', handleClick);
    }

    return () => {
      if (targetNode) {
        targetNode.removeEventListener('click', handleClick);
      }
    };
  }, [translations, setSelectedWord]);

  return (
    <>
      <span>
        <StyledTextWithTranslations
          ref={divRef}
          className={className}
          dangerouslySetInnerHTML={{ __html: updatedHtmlContent }}
        ></StyledTextWithTranslations>
        <TranslationPopover
          {...selectedWord}
          onClose={() => setSelectedWord(null)}
        />
      </span>
    </>
  );
}

function wrapWordsWithSpan(html, translations) {
  try {
    const escapedWords = translations.map((t) =>
      t.word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
    );

    const singleWordPattern = escapedWords
      .filter((word) => !word.includes(' '))
      .map((word) => `\\b${word}\\b`)
      .join('|');

    const phrasePattern = escapedWords
      .filter((word) => word.includes(' '))
      .join('|');

    const pattern =
      phrasePattern && singleWordPattern
        ? `(${phrasePattern}|${singleWordPattern})`
        : phrasePattern || singleWordPattern;

    const regex = new RegExp(pattern, 'gi');

    return html.replace(regex, (match) => {
      const translationIndex = translations.findIndex(
        (t) => t.word.toLowerCase() === match.toLowerCase()
      );
      return `<span class="clickable-word" data-index="${translationIndex}">${match}</span>`;
    });
  } catch (error) {
    console.error('Error:', error);
    return html;
  }
}
